import { render, staticRenderFns } from "./BaseLoadingOverlay.vue?vue&type=template&id=899f215e&scoped=true&"
import script from "./BaseLoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingOverlay.vue?vue&type=style&index=0&id=899f215e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f215e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
